var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V6.8C30 7.9201 30 8.48016 29.782 8.90798C29.5903 9.28431 29.2843 9.59027 28.908 9.78201C28.4802 10 27.9201 10 26.8 10H21.2C20.0799 10 19.5198 10 19.092 9.78201C18.7157 9.59027 18.4097 9.28431 18.218 8.90798C18 8.48016 18 7.9201 18 6.8V4M16.4 44H31.6C33.8402 44 34.9603 44 35.816 43.564C36.5686 43.1805 37.1805 42.5686 37.564 41.816C38 40.9603 38 39.8402 38 37.6V10.4C38 8.15979 38 7.03968 37.564 6.18404C37.1805 5.43139 36.5686 4.81947 35.816 4.43597C34.9603 4 33.8402 4 31.6 4H16.4C14.1598 4 13.0397 4 12.184 4.43597C11.4314 4.81947 10.8195 5.43139 10.436 6.18404C10 7.03968 10 8.15979 10 10.4V37.6C10 39.8402 10 40.9603 10.436 41.816C10.8195 42.5686 11.4314 43.1805 12.184 43.564C13.0397 44 14.1598 44 16.4 44Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.a9e2a813620d3a0213eaa2edb3278b4b.svg";
export { ForwardRef as ReactComponent };